export const spinnerTokens = {
  'spinner-color': 'var(--dp-color-primary)',
  'spinner-size-sm': '16px',
  'spinner-size-md': '24px',
  'spinner-size-lg': '36px',
  'spinner-border-width': '2px',
  'spinner-speed': '0.8s',
  'spinner-track-color': 'var(--dp-color-border)',
} as const;
